import { render, staticRenderFns } from "./GroupRadioWithExtraOption.vue?vue&type=template&id=2b2dfde0&scoped=true&lang=pug"
import script from "./GroupRadioWithExtraOption.vue?vue&type=script&lang=js"
export * from "./GroupRadioWithExtraOption.vue?vue&type=script&lang=js"
import style0 from "./GroupRadioWithExtraOption.vue?vue&type=style&index=0&id=2b2dfde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2dfde0",
  null
  
)

export default component.exports